


import watchNewFuncionarioCargoCadastro from './saga/new';
import watchFindFuncionarioCargoCadastro from './saga/find';
import watchCreateFuncionarioCargoCadastro from './saga/create';
import watchListAllFuncionarioCargoCadastro from './saga/listAll';
import watchListFuncionarioCargoCadastro from './saga/listTable';
import watchDeleteFuncionarioCargoCadastro from './saga/delete';
import watchCancelFuncionarioCargoCadastroRapido from './saga/cancel';

export const funcionarioCargoCadastroSaga = [
    watchNewFuncionarioCargoCadastro(),
    watchFindFuncionarioCargoCadastro(),
    watchCreateFuncionarioCargoCadastro(),
    watchListAllFuncionarioCargoCadastro(),
    watchListFuncionarioCargoCadastro(),
    watchDeleteFuncionarioCargoCadastro(),
    watchCancelFuncionarioCargoCadastroRapido(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
export * from './entity';
